import { deleteCookies, getCookie } from '../common/utils';
import { acquireTokenUrl, apimSubscriptionKey, signOutUrl, verifyEmailAddressUrl } from '../config';
import { isTokenExpired } from '../common/utils';

const urlsWithoutAccessToken = [
  verifyEmailAddressUrl,
  acquireTokenUrl
  // Add more URLs here as needed
];

export default async (config) => {
  const { headers } = config;
  headers["Ocp-Apim-Subscription-Key"] = apimSubscriptionKey;

  if (urlsWithoutAccessToken.includes(config.url)) {
    return config;
  }

  if (isTokenExpired()) {
    deleteCookies();
    window.location.href = '/';
    return;
  }   
  
  // Add the token to the headers
  const authCookie = getCookie('iotAccessToken');
  headers.authorization = `Bearer ${authCookie}`;
  return { ...config, headers };
  
};
